// src/services/CountryService.js
import api from "./api";

export function getJobs(data) {
    return api.post(`/jobs/filterjobs`, data);
}

export function getJobData(id) {
    return api.get(`/jobs/${id}`);
}

export function getCities(page = 1, limit = 10, country_id) {
    return api.get(
        `/jobs/getcitydropdown?page=${page}&limit=${limit}&country_id=${country_id}&list=all`
    );
}
